import React, { HTMLAttributes } from 'react';

import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphLinkList as Type } from '../../../types/uncinc_profile/paragraphs';
import { LinkList } from '../../../components';

interface ParagraphLinkListProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphLinkList: React.FC<ParagraphLinkListProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const links = paragraph.field_paragraphs;

  return (
    <div id={uuid} className="ParagraphLinkList">
      <Container>
        <Text
          title={title}
          text={body || ''}
        />
        <LinkList>
          {links.map((link) => (
            <LinkList.PrimaryItem
              title={link.entity.field_title[0].value}
              subtitle={String(link.entity.field_body[0].processed)}
              link={link.entity.field_link[0].alias || link.entity.field_link[0].uri}
            />
          ))}
        </LinkList>
      </Container>
    </div>
  );
};

export default ParagraphLinkList;
